import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Parallax, Background } from 'react-parallax'

import { ZIndex } from '../themes/Metrics'
import { Col12 } from '../components/common/Grid'

import Team from '../components/sections/team/Team'
import Games from '../components/sections/games/Games'
import Banner from '../components/sections/banner/Banner'
import Contact from '../components/sections/contact/Contact'
import Process from '../components/sections/process/Process'
import Services from '../components/sections/services/Services'
import Statitis from '../components/sections/statitis/Statitis'
import VideoPopup from '../components/sections/video-popup/VideoPopup'
import Testimonials from '../components/sections/testimonial/Testimonials'

export default class IndexPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      videoBannerRef: null,
      isShowVideoPopup: false
    }
  }

  handleShowVideoPopup = () => {
    this.setState({
      isShowVideoPopup: !this.state.isShowVideoPopup
    })
  }

  render() {
    // Testimonials data
    const testimonials = this.props.data.allContentfulTestimonial.edges

    // Games data
    const games = this.props.data.allContentfulGame.edges

    // Services data
    const services = this.props.data.allContentfulService.edges

    const {
      team,
      banner,
      teamGame,
      teamDesign,
      aboutUsGame,
      aboutUsDesign,
      handleToggleModal,
    } = this.props

    return (
      <Col12
        customStyle={{
          position: 'relative',
          zIndex: ZIndex.medium
        }}
      >
        <Banner
          banner={banner}
          handleToggleModal={handleToggleModal}
          handleShowVideoPopup={this.handleShowVideoPopup}
        />
        <Games data={games} id='work' />
        <Services data={services} id='services' />
        <Parallax
          strength={200}
        >
          <Background />
          <Process
            handleToggleModal={handleToggleModal}
          />
          <Team
            id='about'
            team={team}
            teamGame={teamGame}
            teamDesign={teamDesign}
            aboutUsGame={aboutUsGame}
            aboutUsDesign={aboutUsDesign}
          />
          <Statitis
            aboutUsGame={aboutUsGame}
            aboutUsDesign={aboutUsDesign}
          />
        </Parallax>
        <Testimonials data={testimonials} />
        <Contact handleToggleModal={handleToggleModal} />
        <VideoPopup
          isShowVideoPopup={this.state.isShowVideoPopup}
          handleShowVideoPopup={this.handleShowVideoPopup}
        />
      </Col12>
    )
  }
}

IndexPage.PropTypes = {
  data: PropTypes.object.isRequired
}

export const query = graphql`
  query pageQuery {
    allContentfulTestimonial(
      filter: {
        node_locale: {eq: "en-US"}
      },
      sort: {
        fields: [createdAt], order: DESC
      }
    ) {
      edges {
        node {
          id
          createdAt
          role
          client
          text {
            id
            text
          }
        }
      }
    }
    allContentfulGame(
      filter: {
        node_locale: {eq: "en-US"}
      },
      sort: {
        fields: [uid], order: ASC
      }
    ) {
      edges {
        node {
          uid
          id
          title
          slug
          description
          tags
          genre
          createdAt
          banner {
            sizes(maxWidth: 800, quality: 80) {
              ...GatsbyContentfulSizes
            }
          }
        }
      }
    }
    allContentfulService(
      filter: {
        node_locale: {eq: "en-US"}
      },
      sort: {
        fields: [createdAt], order: DESC
      }
    ) {
      edges {
        node {
          id
          slug
          name
          description {
            id
            description
          }
          icon {
            id
            file {
              url
            }
          }
          createdAt
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js